import { css } from '@emotion/react';
import { Gray, White } from '@constants/color';

export const contentContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

export const loadingAnimation = css({
  width: 400,
  height: 400
});

export const title = css({
  fontSize: 48,
  fontWeight: 700,
  lineHeight: '62.4px',
  color: White.White10
});

export const instructions = css({
  marginTop: 40,
  textAlign: 'center'
});

export const instruction = css({
  fontSize: 24,
  fontWeight: 500,
  lineHeight: '43.2px',
  color: Gray.Gray60
});
